<template>
  <v-dialog persistent v-model="isShowRecordFailDialog" max-width="400">
    <v-card class="container-record-fail px-5 py-3" color="#21343b" width="auto">
      <v-row no-gutters align="center" justify="center">
        <v-col class="px-5 mt-2" :cols="12" align="start" justify="center">
          <span class="record-fail-content">{{ $t('recordFailMsg') }}</span>
        </v-col>

        <v-row class="container-btn my-4 mx-5" no-gutters align="start" justify="center">
          <v-col cols="5" align-self="center">
            <v-btn block height="40" elevation="0" color="#869399" @click="$emit('close')">
              {{ $t('cancel') }}
            </v-btn>
          </v-col>
          <v-col cols="5" class="ml-2" align-self="center">
            <v-btn block height="40" elevation="0" color="#ff575f" @click="reload()">
              {{ $t('reload') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'RecordFailDialog',
  props: ['isShowRecordFailDialog'],
  methods: {
    reload() {
      location.reload()
    },
  },
}
</script>

<style scoped>
.v-dialog__content >>> .v-dialog {
  overflow: hidden;
}
.container-record-fail {
  border-radius: 10px;
}
.record-fail-title {
  font-weight: bold;
  font-size: 20px;
  color: white;
}
.record-fail-content {
  font-size: 14px;
  color: #96a7af;
}
.container-btn >>> .v-btn * {
  font-size: 14px;
  color: white;
  letter-spacing: 0;
  text-transform: none;
  font-weight: bold;
}
.container-btn .btn-control {
  width: 45px;
  height: 45px;
  background-color: #161d21;
  padding: 0 !important;
  min-width: 45px !important;
}
</style>
